<template>
  <main v-if="$page" id="main">
    <HeaderSection :content="$page.header" />
    <MenusSection />
    <RepeatableSection
      v-for="(section, index) in $page.sections"
      :content="section"
      :key="`concept-${index}`"
      :id="index === 0 ? 'concept' : null"
    />
    <LargeImageSection :content="$page.ambience" />
    <ImagesSwiperSection :content="$page.happiness" />
    <VirtualVisitSection :content="$page.virtualVisit" />
    <PartnerSection :content="$page.partners" />
    <RestaurantsSection :content="$page.restaurants" />
  </main>
</template>

<script>
import HeaderSection from '@/components/sections/HeaderSection.vue'
import ImagesSwiperSection from '@/components/sections/ImagesSwiperSection.vue'
import LargeImageSection from '@/components/sections/LargeImageSection.vue'
import MenusSection from '@/components/sections/MenusSection.vue'
import PartnerSection from '@/components/sections/PartnerSection.vue'
import RepeatableSection from '@/components/sections/RepeatableSection.vue'
import RestaurantsSection from '@/components/sections/RestaurantsSection.vue'
import VirtualVisitSection from '@/components/sections/VirtualVisitSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  name: 'Home',
  beetPage: 'home',
  inject: ['mq'],
  mixins: [PageMetaMixin],
  components: {
    PartnerSection,
    HeaderSection,
    ImagesSwiperSection,
    LargeImageSection,
    Loader,
    MenusSection,
    RepeatableSection,
    RestaurantsSection,
    VirtualVisitSection,
  },
}
</script>
